import { render } from "./InviteSSOUsers.vue?vue&type=template&id=b2f2e254&scoped=true&ts=true"
import script from "./InviteSSOUsers.vue?vue&type=script&lang=ts"
export * from "./InviteSSOUsers.vue?vue&type=script&lang=ts"

import "./InviteSSOUsers.vue?vue&type=style&index=0&id=b2f2e254&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f2e254"]])

export default __exports__